import React from 'react';
import './site.css';

function Menu() {
  return (
    <nav className="navbar fixed-top navbar-expand-md site-navbar navbar-dark">
      <div className="container">
        <a className="navbar-brand" href="https://www.redesupermarket.com.br/" target="_blank" rel="noreferrer">
          <img
            className="logosm"
            src="https://redesupermarket.com.br/wp-content/uploads/2025/12/logo-150-cor.png"
            alt="Rede Supermarket"
            title="Rede Supermarket"
          />
        </a>

        <button
          className="navbar-toggler border-0"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#siteNavbar"
          aria-controls="siteNavbar"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="siteNavbar">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <a className="nav-link" href="https://www.redesupermarket.com.br/" target="_blank" rel="noreferrer">
                <i className="fa fa-shopping-cart" /> Supermarket
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#features">
                <i className="fa fa-th-large" /> Acessos
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#preco">
                <i className="fa fa-play-circle" /> Vídeos
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#footer">
                <i className="fa fa-envelope" /> Contatos
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Menu;